import { http, HttpResponse } from 'msw';

export const draftConsentHandler = [
    http.post('*/api/cl_loanapp_proxy_service/v1/:countryCode/drafts/:arn/consents', async () => {
        return HttpResponse.json({});
    }),
];
